import { useEffect, useState } from "react";
import FavoriteLinks from "../components/FavoriteLinks";
import { getIdToken } from "../utils/authUtils"; // ← JWT取得関数をインポート

const fetchFavorites = async (userid) => {
  try {
    const token = await getIdToken(); // ← JWT取得
    if (!token) throw new Error("JWT取得失敗");

    const res = await fetch(`${process.env.REACT_APP_API_URL}/favorites/${userid}`, {
      headers: {
        Authorization: `Bearer ${token}`, // ← JWTをヘッダーに追加
      },
    });

    console.log("[DEBUG] API URL:", res.url);
    const json = await res.json();
    console.log("[DEBUG] API Response:", json);
    return json || [];
  } catch (err) {
    console.error("Fetch failed:", err);
    return [];
  }
};

function Home() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userid = process.env.REACT_APP_DEFAULT_USERID;
    console.log("[DEBUG] userid:", userid);
    fetchFavorites(userid).then((items) => {
      console.log("[DEBUG] favorites:", items);
      setFavorites(items);
      setLoading(false);
    });
  }, []);

  return (
    <section>
      <h2>お気に入りリンク集</h2>
      {loading ? (
        <p>読み込み中...</p>
      ) : (
        <FavoriteLinks favorites={favorites} />
      )}
    </section>
  );
}

export default Home;